import { render, staticRenderFns } from "./VueQrReader.vue?vue&type=template&id=64b3322e&scoped=true&"
import script from "./VueQrReader.vue?vue&type=script&lang=js&"
export * from "./VueQrReader.vue?vue&type=script&lang=js&"
import style0 from "./VueQrReader.vue?vue&type=style&index=0&id=64b3322e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b3322e",
  null
  
)

export default component.exports